require('./header-control-bar/header-control-bar-kiosk.scss');
var Button = require('treeline-shared-components/button.js');
var ShoppingCartIndicator = require('./cart/shopping-cart-indicator');
var SpinnerButton = require('treeline-shared-components/spinner-button');
var FarmBranding = require('./farm-branding.js');
var HamburgerButton = require('./header-control-bar/hamburger-button');
var SearchButton = require('./header-control-bar/search-button');
var ProfileButton = require('./header-control-bar/profile-button');
var CategoryTextMenu = require('./menu/category-text-menu');
var BaseViews = require('./base');

var HeaderControlBar = BaseViews.LayoutView.extend({
    _expandedMap: false,
    template: require('./header-control-bar/header-control-bar-kiosk.html'),
    className: 'fmcy-header-control-bar-kiosk fmcy-plugin-bootstrap container-fluid',
    initialize: function (options) {
        var self = this;
        this.options = _.defaults(
            options || {},
            {
                _appChannel: null,
                _menuState: null
            }
        );
    },
    regions : {
      headerNavSearchRegion: '.fmcy-header-bar-nav-search-region',
      headerBrandingRegion: '.fmcy-header-branding-region'
    },
    ui: {
      headerNavHamburgerRegion: '.fmcy-header-bar-nav-hamburger-region',
      headerNavSearchRegion: '.fmcy-header-bar-nav-search-region',
      joinButton: '.register-button',
      cannabisButton: '.cannabis-button',
      cannabisButtonColumn: '.cannabis-button-column',
      salesButtonColumn: '.sales-button-column',
      cbdButton: '.cbd-button',
      cbdButtonColumn: '.cbd-button-column',
      accessoriesButton: '.accessories-button',
      accessoriesButtonColumn: '.accessories-button-column'
    },
    events : {
      'click @ui.cannabisButtonColumn': '_cannabisButtonClicked',
      'click @ui.cbdButtonColumn': '_cbdButtonClicked',
      'click @ui.salesButtonColumn': '_saleButtonClicked',
      'click @ui.accessoriesButtonColumn': '_accessoriesButtonClicked'
    },
    _resetTabs: function () {
      this.ui.cannabisButtonColumn.css('backgroundColor', '#000000');
      this.ui.accessoriesButtonColumn.css('backgroundColor', '#000000');
    },
    _cannabisButtonClicked: function () {
      this.options._appChannel.trigger('menu:overlay:view:close');

      this.ui.cannabisButtonColumn.css('backgroundColor', '#00afb4');

      this.options._appChannel.trigger('display:mega:menu', {
        childView: new CategoryTextMenu({
          _menuState: this.options._menuState,
          _appChannel: this.options._appChannel,
          parentCategorySlug: 'cannabis',
          mode: 'kiosk',
          defaultMenuHeight: 900,
          categories: this.options._menuState.get('menuItemCategories')
        }),
        backgroundColor: '#e3e3e2',
        textColor: '#000000'
      });
    },
    _cbdButtonClicked: function () {
      this.options._appChannel.trigger('menu:overlay:view:close');
      this.options._appChannel.request(
          'load:category',
          'cbd-products',
          'all',
          {}
      );
    },
    _saleButtonClicked: function () {
      this.options._appChannel.trigger('menu:overlay:view:close');
      this.options._appChannel.request(
          'load:category',
          'all',
          null,
          {
            weeklysales: true
          }
      );
    },
    _accessoriesButtonClicked: function () {
      this.options._appChannel.trigger('menu:overlay:view:close');

      this.ui.accessoriesButtonColumn.css('backgroundColor', '#00afb4');

      this.options._appChannel.trigger('display:mega:menu', {
        childView: new CategoryTextMenu({
          _menuState: this.options._menuState,
          _appChannel: this.options._appChannel,
          parentCategorySlug: 'accessories',
          mode: 'kiosk',
          defaultMenuHeight: 900,
          categories: this.options._menuState.get('menuItemCategories'),
        }),
        backgroundColor: '#393a3a',
        textColor: '#ffffff'
      });
    },
    hide: function () {
      this.$el.hide();
    },
    show: function () {
      this.$el.show();
    },
    _renderFarmLogo: function () {
      var self = this;
      this._branding = new FarmBranding({
        style: 'full'
      });
      this._branding.on('clicked', function () {
        self.options._appChannel.trigger('kiosk:show:intro');
      });
      this.headerBrandingRegion.show(this._branding);
    },
    _renderLocationSelectView: function () {
      this.options._appChannel.trigger('menu:overlay:view:close');
      this.options._appChannel.trigger('location:selection:view',
      {
        referrer: 'entry',
        skipAgeGate: true
      });
    },
    _renderSearchButton: function () {
      var self = this;
      this._searchButton = new SearchButton({
        _appChannel: this.options._appChannel,
        notificationCount: this.options._appChannel.request('orders:ready:count')
      });

      this.listenTo(this.options._menuState, 'change:searchOpen', function (model) {
        self._searchButton.toggleIcon(model.get('searchOpen'));
        if (model.get('searchOpen')) {
          // note ui
          self.ui.headerNavSearchRegion.addClass('fmcy-header-bar-nav-sidebar-active');
        } else {
          self.ui.headerNavSearchRegion.removeClass('fmcy-header-bar-nav-sidebar-active');
        }
      });

      this.headerNavSearchRegion.show(this._searchButton);
    },
    serializeData: function () {
      return {
        rootUrl: window.location.protocol + '//' + window.location.hostname,
        isUserLoggedIn: this.options.isUserLoggedIn
      }
    },
    onRender: function () {
      var self = this;
      self._renderFarmLogo();

      this.options._appChannel.on('menu:overlay:view:close', function () {
        self._resetTabs();
      });
    }
});
module.exports = HeaderControlBar;



/** WEBPACK FOOTER **
 ** ./assets/js/common/header-control-bar-kiosk.js
 **/